<template lang="html">
  <process-interview-videointerview-scene
    v-if="interview"
    :interview="interview"
    :is-videoresume="isVideoresume"
  />
</template>

<script>
  export default {
    name: 'InterviewVideointerviewScene',

    props: {
      interview: Object,
      isVideoresume: Boolean
    }
  };
</script>
